import React from 'react';

import { PaymentMethods } from './AccountUtils';
import FeeMessage from './FeeMessage';
import Program from './Program';


const TippingModalContent = (props) => {
  const {
    isGift,
    epochAvailable,
    selectedPaymentMethod,
    paysafeAvailable,
    oneClickPaymentData,
    onPaymentMethodChange,
    programs,
    handlePackageChange,
    activeProgram,
    submitButtonDisabled,
    onSubmitClick,
    renderFeeMessage,
  } = props;
  const buttonClassName = submitButtonDisabled ? 'submitButtonDisabled' : '';
  if (!isGift) {
    return null;
  }

  return (
    <form
      action="/account/submission"
      id="package_selection_form"
      method="POST"
    >
      <div className="giftingPackages">
        <PaymentMethods
          epochAvailable={epochAvailable}
          oneClickPaymentData={oneClickPaymentData}
          paysafeAvailable={paysafeAvailable}
          selectedPaymentMethod={selectedPaymentMethod}
          onPaymentMethodChange={onPaymentMethodChange}
        />
        {programs.map((pack) => (
          <Program
            key={`gift-${pack.id}`}
            activeProgram={activeProgram}
            handlePackageChange={handlePackageChange}
            pack={pack}
          />
        ))}
        <FeeMessage
          shouldRenderFeeMessage={renderFeeMessage}
        />
        <button
          className={`sendGiftButton ${buttonClassName}`}
          disabled={submitButtonDisabled}
          type="button"
          onClick={onSubmitClick}
        >
          Send Tip
        </button>
      </div>
    </form>
  );
};

export default TippingModalContent;
